import { render } from "./AdminFormAlert.vue?vue&type=template&id=48946e27&scoped=true"
import script from "./AdminFormAlert.vue?vue&type=script&lang=js"
export * from "./AdminFormAlert.vue?vue&type=script&lang=js"

import "./AdminFormAlert.vue?vue&type=style&index=0&id=48946e27&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48946e27"]])

export default __exports__